import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "substep-wrapper" }
const _hoisted_2 = { class: "substep-content" }
const _hoisted_3 = { class: "sections" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = { class: "button-text" }
const _hoisted_7 = {
  class: "buttons",
  id: "repayment-terms"
}
const _hoisted_8 = { class: "button-text" }
const _hoisted_9 = {
  class: "column",
  style: {"flex":"1"}
}
const _hoisted_10 = {
  class: "buttons",
  id: "repayment-types",
  style: {}
}
const _hoisted_11 = { class: "substep-footer" }
const _hoisted_12 = {
  class: "button-container",
  id: "button-container"
}
const _hoisted_13 = ["disabled"]

import { computed, ref } from "vue";
import RepaymentTermSelection from "@/components/professional-grad/loan-configuration/RepaymentTermSelection.vue";
import RateTypeSelection from "@/components/professional-grad/loan-configuration/RateTypeSelection.vue";
import RepaymentTypeSelection from "@/components/professional-grad/loan-configuration/RepaymentTypeSelection.vue";
import RepaymentTypeButton from "@/components/professional-grad/loan-configuration/RepaymentTypeButton.vue";
import NextButton from "@/components/shared/NextButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Confirmation',
  props: {
    rateTypeSelectionRef: {},
    repaymentTermSelectionRef: {},
    repaymentTypeSelectionRef: {},
    isCurrent: { type: Boolean }
  },
  emits: ["previous", "complete"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const confirmationSummary = computed(() => {
  return {
    rateTypes: props.rateTypeSelectionRef?.rateTypes,
    repaymentTerms: props.repaymentTermSelectionRef?.repaymentTermOptions,
    repaymentTypes: props.repaymentTypeSelectionRef?.repaymentTypeOptions,
    selectedRateTypeId: props.rateTypeSelectionRef?.selectedRateTypeId,
    selectedRepaymentTermId: props.repaymentTermSelectionRef?.selectedRepaymentTermId,
    selectedRepaymentTypeId: props.repaymentTypeSelectionRef?.selectedRepaymentTypeId,
    selectedRatePlanId: props.repaymentTypeSelectionRef?.selectedRatePlan?.id,
  };
});

const savingChanges = ref<boolean>(false);

function handleSubmit() {
  savingChanges.value = true;
  emit("complete");
}

function setSavingChanges(flag: boolean) {
  savingChanges.value = flag;
}

__expose({
  savingChanges,
  setSavingChanges,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["substep", ['subitem-5']])
    }, [
      _cache[6] || (_cache[6] = _createStaticVNode("<h1 class=\"title\" data-v-782ed87b>Finalize Your Details</h1><p class=\"description\" data-v-782ed87b><span class=\"desktop\" data-v-782ed87b>Confirm your interest rate type and repayment term on the left, along with your repayment type below. <b class=\"disclaimer\" data-v-782ed87b>Please note, once final documents have been provided and generated, changes to these selections can not be made.</b></span><span class=\"mobile\" data-v-782ed87b>Confirm your interest rate type, repayment term, and repayment type below. <b class=\"disclaimer\" data-v-782ed87b>Please note, once your final loan documents are generated, these selections cannot be changed.</b></span></p>", 2)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "section-title" }, "Interest Rate Type", -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmationSummary.value.rateTypes, (rateType) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: rateType.rateTypeId,
                    class: _normalizeClass(["option-button", [
                    {
                      active: __props.rateTypeSelectionRef?.isActive(rateType.rateTypeId),
                      'default-btn': !__props.rateTypeSelectionRef?.isActive(rateType.rateTypeId),
                    },
                  ]])
                  }, [
                    _createElementVNode("h5", _hoisted_6, _toDisplayString(rateType.rateTypeName), 1)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "section-title" }, "Repayment Term", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.repaymentTermSelectionRef?.repaymentTermOptions, (repaymentTermOption) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: repaymentTermOption.repaymentTermId,
                    class: _normalizeClass(["option-button", [
                    {
                      active: __props.repaymentTermSelectionRef?.isActive(
                        repaymentTermOption.repaymentTermId,
                      ),
                      'default-btn': !__props.repaymentTermSelectionRef?.isActive(
                        repaymentTermOption.repaymentTermId,
                      ),
                    },
                  ]])
                  }, [
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(repaymentTermOption.repaymentTerm), 1)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "section-title" }, "Repayment Type", -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmationSummary.value.repaymentTypes, (repaymentTypeOption) => {
                  return (_openBlock(), _createBlock(RepaymentTypeButton, {
                    readonly: true,
                    key: repaymentTypeOption?.repaymentTypeId || '',
                    repaymentTypeOption: repaymentTypeOption,
                    selectedRepaymentTypeId: confirmationSummary.value.selectedRepaymentTypeId
                  }, null, 8, ["repaymentTypeOption", "selectedRepaymentTypeId"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "previous-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('previous'))),
            disabled: savingChanges.value
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "button-text" }, [
              _createElementVNode("span", { class: "button-text" }, "Back")
            ], -1)
          ]))], 8, _hoisted_13),
          _createVNode(NextButton, {
            class: "next-btn",
            onClick: handleSubmit,
            loading: savingChanges.value,
            text: "Complete"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "button-text" }, "Complete", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})